import IStoreOrderbook from 'model/IStoreOrderbook';
import ReduxRootState from 'model/Redux/ReduxRootSate';
import ReduxActionInterface from 'model/ReduxActionInterface';
import { ORDERBOOK_LOADING, ORDERBOOK_ERROR, ORDERBOOK_SUCCESS } from './actionsType';

const ROOT_VALUE_STATE: ReduxRootState<IStoreOrderbook[]> = {
    loading: false,
    data: [],
};

export const orderbookReducer = (state: ReduxRootState<IStoreOrderbook[]> = ROOT_VALUE_STATE, action: ReduxActionInterface<IStoreOrderbook>) => {
    switch (action.type) {
        case ORDERBOOK_LOADING:
            return {
                ...state,
                loading: true,
            };
        case ORDERBOOK_ERROR: {
            return {
                ...state,
                loading: false,
                error: 'Error while loading orderbook',
            };
        }
        case ORDERBOOK_SUCCESS:
            if (!action.payload || action.payload.orderbook.length === 0)
                return { ...state, loading: false };
            const stateCopy: ReduxRootState<IStoreOrderbook[]> = { ...state };
            const assetOrderbookIndex: number = stateCopy.data.findIndex(entry => entry.assetId === action.payload.assetId && entry.side === action.payload.side);
            if (assetOrderbookIndex === -1) {
                state.data.push(action.payload);
                return {
                    ...state,
                    loading: false,
                };
            }
            stateCopy.data[assetOrderbookIndex] = {
                ...stateCopy.data[assetOrderbookIndex],
                orderbook: action.payload.orderbook,
                totalOrders: action.payload.totalOrders,
            };
            return {
                ...state,
                data: [
                    ...stateCopy.data,
                ],
                loading: false,
            };
        default:
            return state;
    }
};
